import React, {useEffect, useState, useRef, use} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { listPlaylistVideos,  arrangeVideos } from '../../actions/PlaylistActions'
import { useParams } from 'react-router-dom'
import arrowLeft from '../icons/Arrow_left.svg'
import { useNavigate, useNavigationType } from 'react-router-dom';
import UserPlaylistComponent from './UserPlaylistComponent';
import Play_All from '../icons/PLAY_ALL.svg'
import { formatSeconds } from '../../utils/formatTime'
import {
    DndContext, 
    closestCorners,
    KeyboardSensor,
    MouseSensor,
    TouchSensor,
    useSensor,
    useSensors,
} from "@dnd-kit/core"
import {
    arrayMove,
    SortableContext,
    horizontalListSortingStrategy,
    sortableKeyboardCoordinates,
  } from "@dnd-kit/sortable";


const UserPlaylistPage = () => {

    const {playlist_id, playlist_title} = useParams()

    const dispatch = useDispatch()

    const navigate = useNavigate()

    const [items, setItems] = useState()

    const playlistVideosRef = useRef(null);

    const navigationType = useNavigationType();

    const { loading, playlistVideos } = useSelector(state => state.userPlaylists)
  
    useEffect(()=>{

        localStorage.setItem("path", `/playlist/${playlist_id}/${playlist_title}`)
        dispatch(listPlaylistVideos(playlist_id))
        window.scrollTo(0, 0)

    },[dispatch, playlist_id])


    useEffect(()=>{
        if(playlistVideos && playlistVideos.length){
            setItems(playlistVideos)
        }
    },[playlistVideos])


    const playallClickHandler = () => {
        let group_id = localStorage.getItem('group_id')
        if (playlistVideos && playlistVideos.length){
            let first_video = playlistVideos[0]
            localStorage.setItem('video_id', first_video.id)
            localStorage.setItem('playlist_id', playlist_id)
            navigate(encodeURI(`/home?g=${group_id}&p=${playlist_id}&v=${first_video.id}`, {replace: false} ))
        }
    }


    useEffect(()=>{
        if(items && items.length){    
            if(navigationType === "POP"){    
                playlistVideosRef?.current.scrollTo({
                    top: sessionStorage.getItem("results-scroll") || 0,
                    behavior: "auto"
                })
            } else {
                playlistVideosRef?.current.scrollTo({
                    top: 0,
                    behavior: "auto"
                })
            }
        }
    },[items, navigationType])


    const handleScroll = event => {

        const {scrollTop, clientHeight, scrollHeight} = event.currentTarget;
        sessionStorage.setItem("results-scroll", scrollTop);

        } 



    const sensors = useSensors(
        useSensor(MouseSensor, {
        // Require the mouse to move by 10 pixels before activating
        activationConstraint: {
            distance: 10,
        },
        }),
        useSensor(TouchSensor, {
        // Press delay of 250ms, with tolerance of 5px of movement
        activationConstraint: {
            delay: 250,
            tolerance: 5,
        },
        }),
        useSensor(KeyboardSensor, {
        coordinateGetter: sortableKeyboardCoordinates,
        })
    );
      

    const handleDragEnd = (event) => {
      const {active, over} = event;
      if (active.id !== over.id) {
        setItems((items) => {
          const oldIndex = items.map(item=>item.position).indexOf(active.id);
          const newIndex = items.map(item=>item.position).indexOf(over.id);
          if (active.id>over.id){
              items.forEach(item => {
                  if(item.position < active.id && item.position >= over.id){
                      item.position += 1
                  } else if (item.position === active.id){
                      item.position = over.id
                  }
              });
          } else if (active.id<over.id){
              items.forEach(item => {
                  if(item.position > active.id && item.position <= over.id){
                      item.position -= 1
                  } else if (item.position === active.id){
                      item.position = over.id
                  }
              });
          } 
          return arrayMove(items, oldIndex, newIndex);
        });
        dispatch(arrangeVideos(playlist_id, active.id, over.id))
      }
  }


  return (
        <div className = "w-100 bg-bluedark d-flex flex-column align-items-center page-bg-fill">
            <div className = "w-100 d-flex flex-column align-items-center"
            style={{maxHeight:"calc(100vh - 5rem)"}}
            >
            { 
                loading ? <div className = "text-info col-12 col-lg-10" >Loading...</div> :
                <>
                    <div className = "col-12 pt-3 pt-md-5 col-lg-10 d-flex flex-column flex-md-row justify-content-center align-items-start">
                        <div className = 'col-12 col-md-6 px-3 px-md-5 d-flex align-items-center justify-content-start'>
                            <img
                                src = {arrowLeft}
                                role = 'button'
                                onClick={()=>navigate(-1)}
                                alt = ''
                                className='flex-shrink-0'
                                style={{height:"17px", width:"auto"}}
                                />
                            <div className='ps-3 text-white fs-7 page-title text-truncate flex-grow-1'
                                style={{minWidth:0}}
                                title={playlist_title}
                            >{playlist_title}</div>
                            <img
                                className='ps-3 flex-shrink-0'
                                src = {Play_All}
                                role = 'button'
                                onClick={()=>playallClickHandler()}
                                alt = ''
                                style={{height:"28px", width:"auto"}}
                            />
                        </div>
                        <div className='col-12 col-md-6 d-flex px-2 px-md-5 justify-content-end'>
                            {
                                playlistVideos && playlistVideos.length ?
                                <>
                                    <div className = "text-info px-3 text-nowrap">{playlistVideos.length} Videos</div>
                                    <div className = "text-info px-3 border-start border-info text-nowrap">{formatSeconds(playlistVideos.reduce((sum, item) => sum + item.duration, 0))} </div>

                                </>: ""
                            }
                        </div>
                    </div>
                    <DndContext 
                        sensors={sensors}
                        collisionDetection={closestCorners}
                        onDragEnd={handleDragEnd}
                        >
                        {
                            items && items.length ? 

                        <div className='col-12 col-lg-10 px-4 d-flex flex-row flex-wrap results-wrapper'
                            ref={playlistVideosRef}
                            onScroll = {handleScroll}>
                                <SortableContext items = {items.map(video=>video.position)} strategy={horizontalListSortingStrategy}>
                                    {
                                        items.map((video)=>(
                                            <UserPlaylistComponent
                                                video = {video}
                                                key = {video.id}
                                                playlist_id = {playlist_id}
                                                setItems = {setItems}
                                            />
                                    )) 
                                    }
                                </SortableContext>
                           </div> : ""
                        }
                        </DndContext>
                </>
            }
            </div>  
        
        </div>
    );
};

export default UserPlaylistPage;